import RoomPage from '../RoomPage';

const EngineerRoom = () => {
  return (
    <RoomPage
      roomName="Engineer"
      roomTitle="Web制作"
      description="静かに、丁寧に。言葉にならない想いを形にするWeb制作。派手な演出より、訪れた人がふと落ち着けるような空間を目指しています。"
      heroGradient={{
        from: '#032A2A',
        to: '#043B3A',
      }}
      works={[
        {
          title: 'コーポレートサイト',
          description: '企業の世界観を静かに伝えるサイト制作',
        },
        {
          title: 'ポートフォリオ',
          description: '個人の作品や活動を美しく見せる場所',
        },
        {
          title: 'ランディングページ',
          description: '一つのメッセージを深く届ける単ページ',
        },
        {
          title: 'システム開発',
          description: 'システムを開発して、サービスを提供します。',
        },
        {
          title: '対応言語',
          description: 'HTML, CSS, JavaScript, React, Next.js, TypeScript, Kotlin, Java, Tailwind CSS, Node.js, Express, MongoDB, MySQL, PostgreSQL, AWS, Azure, GCP, Docker, Kubernetes, CI/CD, DevOps',
        },
        {
          title: 'デザイン',
          description: 'デザインを担当して、サイトを美しくします。',
        },
        {
          title: 'プロジェクトマネージャー',
          description: 'プロジェクトを管理して、進行状況を把握します。',
        },
      ]}
    />
  );
};

export default EngineerRoom;